// Copied from https://stackoverflow.com/questions/6108819/javascript-timestamp-to-relative-time
export function timeDifference(current, previous) {
    var msPerMinute = 60 * 1000;
    var msPerHour = msPerMinute * 60;
    var msPerDay = msPerHour * 24;
    var msPerWeek = msPerDay * 7;
    var msPerMonth = msPerDay * 30;
    var msPerYear = msPerDay * 365;
    var elapsed = current.getTime() - previous.getTime();
    if (elapsed < msPerMinute) {
        return buildText(elapsed / 1000, 'second');
    }
    else if (elapsed < msPerHour) {
        return buildText(elapsed / msPerMinute, 'minute');
    }
    else if (elapsed < msPerDay) {
        return buildText(elapsed / msPerHour, 'hour');
    }
    else if (elapsed < msPerWeek) {
        return buildText(elapsed / msPerDay, 'day');
    }
    else if (elapsed < msPerMonth) {
        return buildText(elapsed / msPerWeek, 'week');
    }
    else if (elapsed < msPerYear) {
        return buildText(elapsed / msPerMonth, 'month');
    }
    else {
        return buildText(elapsed / msPerYear, 'year');
    }
}
function buildText(unit, unitName) {
    var roundedUnit = Math.round(unit);
    return roundedUnit === 1 ? "a ".concat(unitName, " ago") : "".concat(roundedUnit, " ").concat(unitName, "s ago");
}
//# sourceMappingURL=timeDiff.js.map